module.exports = __webpack_public_path__ + "img/icon_arrow_letter.afb1dee8.svg";